exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ranking {\n  color: #6e6e6e;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 1rem;\n  font-weight: 700;\n  text-align: center;\n  line-height: 1.7;\n  text-transform: uppercase;\n  margin-top: 42px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/azu/Proyectos/impunidad/impunidad-cero-tai/src/app/dboxBars/dboxBars.component.scss
// module id = ../../../../../src/app/dboxBars/dboxBars.component.scss
// module chunks = main